<template>
    <div class="pt-1">
        <v-icon class='pr-2'>fal fa-leaf</v-icon>
        <span class="pr-1" v-show="consumption">{{ consumption }} / 100km (komb.) |</span>
        <span class="pr-1" v-show="emissions">{{ emissions }}g CO2 / km |</span>
        <span class="pr-1" v-show="co2class">( {{ co2class }} )</span>
    </div>
</template>

<script>
    export default {
        name: 'VehicleCardConsumption',
        props: {
            data: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                consumption: '',
                emissions: '',
                co2class: ''
            }
        },

        mounted() {
            //Check consumption
            this.consumption = this.data.consumptions.wltp_consumption_combined
                ? this.data.consumptions.wltp_consumption_combined + 'l'
                : this.data.consumptions.wltp_fuel_consumption_weighted
                    ? this.data.consumptions.wltp_fuel_consumption_weighted + 'l'
                    : this.data.consumptions.wltp_power_consumption_combined
                        ? this.data.consumptions.wltp_power_consumption_combined + 'kWh'
                        : false;

            //Check emissions
            this.emissions = this.data.co2_emissions.wltp_co2_emissions_weighted || this.data.co2_emissions.wltp_co2_emissions
                ? this.data.co2_emissions.wltp_co2_emissions_weighted
                    ? this.data.co2_emissions.wltp_co2_emissions_weighted
                    : this.data.co2_emissions.wltp_co2_emissions
                : false;

            //Check CO2 class
            this.co2class = this.data.co2_classes.wltp_co2_class 
                ? this.data.co2_classes.wltp_co2_class.toUpperCase()
                : this.data.co2_classes.wltp_co2_class_weighted_combined && this.data.co2_classes.wltp_co2_class_depleted_battery
                    ? this.data.co2_classes.wltp_co2_class_weighted_combined.toUpperCase() + '/' + this.data.co2_classes.wltp_co2_class_depleted_battery.toUpperCase()
                    : this.data.co2_classes.wltp_co2_class_weighted_combined
                        ? this.data.co2_classes.wltp_co2_class_weighted_combined.toUpperCase()
                        : this.data.co2_classes.wltp_co2_class_depleted_battery
                            ? this.data.co2_classes.wltp_co2_class_depleted_battery.toUpperCase()
                            : false;
        }
    }
</script>